<form id="tipo_ocorrencia_form" name="tipo_ocorrencia_form" novalidate ng-submit="save(tipo_ocorrencia_form)" ng-class="ocorrenciaClassName(newTipoOcorrencia.tipo.id)">
  <div class="row">
    <div class="col-md-12">
      <div class="checkbox">
        <label>
          <input type="checkbox" ng-model="newTipoOcorrencia.ativo" id="ativo" name="ativo">
          Ativo?
        </label>
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-group" ng-class="{'has-error': tipo_ocorrencia_form.descricao.$invalid}">
        <label for="tipo">Descrição</label>
        <input class="form-control" ng-model="newTipoOcorrencia.descricao" type="text" id="descricao" name="descricao" required maxlength="50">
        <p class="help-block" ng-show="tipo_ocorrencia_form.descricao.$error.required">Informe a descrição</p>
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-group" ng-class="{'has-error': tipo_ocorrencia_form.nomeCientifico.$invalid}">
        <label for="tipo">Nome Científico</label>
        <input class="form-control" ng-model="newTipoOcorrencia.nomeCientifico" type="text" id="nomeCientifico" name="nomeCientifico" maxlength="80">
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-group" ng-class="{'has-error': tipo_ocorrencia_form.tipo.$invalid}">
        <label for="tipo">Tipo</label>
        <ui-select ng-model="newTipoOcorrencia.tipo" theme="bootstrap" id="tipo" name="tipo" required>
          <ui-select-match allow-clear="true">{{$select.selected.descricao}}</ui-select-match>
          <ui-select-choices repeat="tipo in tiposDeOcorrencia | filter: $select.search">
            <span class="form-group" ng-bind-html="tipo.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
        <p class="help-block" ng-show="tipo_ocorrencia_form.tipo.$dirty && tipo_ocorrencia_form.tipo.$error.required">Informe o tipo</p>
      </div>
    </div>

    <div class="col-md-12" ng-if="newTipoOcorrencia.tipo.id == 'invasora'">
      <div class="form-group" ng-class="{'has-error': tipo_ocorrencia_form.classificacao.$invalid}">
        <label for="classificacao">Classificação Invasora</label>
        <ui-select ng-model="newTipoOcorrencia.classificacao" theme="bootstrap" id="classificacao" name="classificacao" required>
          <ui-select-match allow-clear="true">{{$select.selected.descricao}}</ui-select-match>
          <ui-select-choices repeat="classificacao in classificacoes | filter: $select.search">
            <span class="form-group" ng-bind-html="classificacao.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
        <p class="help-block" ng-show="tipo_ocorrencia_form.classificacao.$dirty && tipo_ocorrencia_form.classificacao.$error.required">Informe a Classificação</p>
      </div>
    </div>

    <div class="clearfix"></div>
    <div class="col-md-12">
      <div class="form-group" ng-class="{'has-error': tipo_ocorrencia_form.parteAtacada.$invalid}">
        <label for="tipo">Parte Atacada</label>
        <input class="form-control" ng-model="newTipoOcorrencia.parteAtacada" type="text" id="parteAtacada" name="parteAtacada" maxlength="50">
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-group">
        <label for="tipo">Atividades Alvo</label>
        <ui-select multiple ng-model="newTipoOcorrencia.arrayAtividades" theme="bootstrap" id="atividades" name="atividades" close-on-select="false">
          <ui-select-match placeholder="">{{$item.descricao | capitalize}}</ui-select-match>
          <ui-select-choices repeat="atividade in atividades | filter: $select.search">
            <span class="form-group" ng-bind-html="atividade.descricao | capitalize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-group no-margin">
      <label for="indicadores">Indicadores</label>
        <ui-select ng-model="indicador.selected" on-select="addIndicador($item)" theme="bootstrap" id="indicadores" name="indicadores">
          <ui-select-match allow-clear="true" placeholder="Indicadores">{{$select.selected.titulo + ' - ' + $select.selected.tipo.descricao | capitalize}}</ui-select-match>
          <ui-select-choices repeat="indicador in newTipoOcorrencia.selectIndicadores | orderBy: 'titulo' | filter: $select.search | filter: {selected: false}">
            <span ng-bind-html="indicador.titulo + ' - ' + indicador.tipo.descricao | capitalize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>

    <div class="col-md-12">
      <div ui-sortable="sortableIndicadorOptions" ng-model="newTipoOcorrencia.selectIndicadores" class="list-group">
        <div class="list-group-item" style="cursor: move;" ng-repeat="indicador in newTipoOcorrencia.selectIndicadores track by $index"
             ng-show="indicador.selected">
          <div class="sortable-indicadores">
            <h4 class="list-group-item-heading text-muted">
              {{indicador.titulo | capitalize}} <small>(<b>Tipo: </b>{{indicador.tipo.descricao}})</small>
              <span type="button" class="btn pull-right p-xxs" ng-click="removeIndicador(indicador)">
                <i class="fa fa-times fa-lg" aria-hidden="true"></i>
              </span>
            </h4>
            <div class="list-group-item-text">
              <div class="form-group"
                   ng-class="{'has-error': isValidRange(indicador, newTipoOcorrencia.tipo.id)}">
                - Número de faixas:
                <input type="number" ng-model="indicador.numero_faixas" autocomplete="off"
                       class="form-control">
              </div>
              <div ng-show="indicador.descricao_valor1">
                - {{indicador.descricao_valor1 | capitalize}}
              </div>
              <div ng-show="indicador.descricao_valor2">
                - {{indicador.descricao_valor2 | capitalize}}
              </div>
  
              <div class="row" ng-if="indicador.tipo.temFaixas" >
                <div class="col-xs-12">
                  <b>Faixas de Variação</b>
                </div>
                <indicador-faixas indicador="indicador" ng-if="showFaixas"> </indicador-faixas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row padding-top-10">
    <div class="col-xs-12 btn-group">
      <div class="pull-right">
        <button class="btn btn-default btn-sm btn-action" type="button" ng-click="cancel()">Cancelar</button>
        <button class="btn btn-success btn-sm btn-action" type="submit"
                ng-disabled="tipo_ocorrencia_form.$invalid || !!indicadoresInvalidos.length"
                ng-if="permissions.tipos_ocorrencia.canManage">
          Salvar <i class="fa fa-check"></i>
        </button>
      </div>
    </div>
  </div>
</form>
